import {useQuery} from "react-query";
import {IAgentQuery, IAgentReviewQuery} from "../Base/Base.types";
import AgentSignupApi from "./AgentSignup.api";

export function useGetAgentSignup(query: IAgentQuery){
    return useQuery(["getAgentSignup", query], AgentSignupApi.getData);
}

export function useAgentReviewSearch(query:IAgentReviewQuery){
    return useQuery(["fetchAgentReviewSearch", query], AgentSignupApi.getSearchData);
}

export function useGetAgentDataByID(agentID: string){
    return useQuery([`getAgentByID-${agentID}`, agentID], AgentSignupApi.getDataById);
}